import { render, staticRenderFns } from "./ClientiDataTable.vue?vue&type=template&id=38be1f9f&scoped=true"
import script from "./ClientiDataTable.vue?vue&type=script&lang=js"
export * from "./ClientiDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be1f9f",
  null
  
)

export default component.exports